import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { CompradorDrillDownData } from '@/types/drillDown';
import { CompradorDrillDownContent } from './CompradorDrillDownContent';
import GenericModal from '../GenericModal';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface CompradorDrillDownModalProps {
  open: boolean;
  onClose: () => void;
  data: CompradorDrillDownData | null;
  loading: boolean;
  error: string | null;
  selectedComprador: string | null;
  onRetry: () => void;
}

/**
 * Modal para exibir detalhes do drilldown de compradores
 * Princípio SRP: Responsável apenas pela apresentação do modal de compradores
 * Princípio OCP: Extensível sem modificar código existente
 * Princípio DIP: Depende de abstrações (componentes genéricos) não de implementações concretas
 */
export const CompradorDrillDownModal: React.FC<CompradorDrillDownModalProps> = ({
  open,
  onClose,
  data,
  loading,
  error,
  selectedComprador,
  onRetry
}) => {
  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title={selectedComprador || 'Detalhes do Comprador'}
      loading={false}
      maxWidth="xl"
      fullWidth
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : error ? (
        <Box sx={{ mb: 2, p: 2, bgcolor: 'error.light', borderRadius: 1 }}>
          <Typography color="error" variant="body2">
            {error}
          </Typography>
          <Button 
            onClick={onRetry} 
            variant="outlined" 
            size="small" 
            sx={{ mt: 1 }}
          >
            Tentar Novamente
          </Button>
        </Box>
      ) : (
        data && <CompradorDrillDownContent data={data} />
      )}
    </GenericModal>
  );
}; 